var headerMenu = (() => {
  var setViewAllButtons = () => {
    document.querySelectorAll('[js-mobile-menu-view-all]').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const container = element.closest('.menu-drawer__inner-submenu');
        if (!container) return;
        const backButton = container.querySelector('.menu-drawer__close-button');
        if (backButton) backButton.click();
      });
    });
  }
  var initialize = () => {
    setViewAllButtons();
  }
  return {
    init: initialize
  }
})();

var cartItemImageModal = (() => {
  var showModal = (modal) => {
    modal.classList.add('active');
    modal.style.visibility = 'visible';
  }
  var hideModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('active');
    setTimeout(() => {
      modal.style.visibility = 'hidden';
    }, 200);
  }
  var initialize = () => {
    document.querySelectorAll('[js-cart-item-image-modal] [js-close]').forEach(element => {
      element.addEventListener('click', () => {
        hideModal(element.closest('[js-cart-item-image-modal]'));
      });
    });
  }
  return {
    init: initialize,
    show: showModal
  }
})();

var cartItem = (() => {
  var showCartItemImageModal = (cartItemImage) => {
    if (!cartItemImage.closest('td')) return;
    const cartItemImageModalElement = cartItemImage.closest('td').querySelector('[js-cart-item-image-modal]');
    if (cartItemImageModalElement)
      cartItemImageModal.show(cartItemImageModalElement);
  }
  var initialize = () => {
    cartItemImageModal.init();
    var cartItemImages = document.querySelectorAll('reloaded-tib-image');
    console.log('cartItemImages => ', cartItemImages);
    cartItemImages.forEach(cartItemImage => {
      cartItemImage.addEventListener('click', () => {
        showCartItemImageModal(cartItemImage);
      });
    });
  }
  return {
    init: initialize
  }
})();


var anchorToProductSection = (() => {
  var goToProductSection = () => {
    const targetSection = document.querySelector('.shopify-section.product-section');
    let scrollTop = 0;
    if (window.innerWidth >= 750) {
      scrollTop = targetSection.getBoundingClientRect().top + window.scrollY - 200;
    } else {
      scrollTop = targetSection.getBoundingClientRect().top + window.scrollY;
    }
    window.scrollTo(0, scrollTop);
  }
  var initialize = () => {
    document.querySelectorAll('[js-anchor-to-product-section]').forEach(element => {
      element.addEventListener('click', (e) => {
        if (document.body.classList.contains('landing-product-ab-test-b')) {
          e.preventDefault();
          goToProductSection();
        }
      });
    });
  }
  return {
    init: initialize
  }
})();

var addClassAfterDom = () => {
  document.querySelectorAll('[js-add-class-after-dom]').forEach(element => {
    const classList = element.getAttribute('js-add-class-after-dom').split(' ');
    classList.forEach(className => {
      element.classList.add(className);
    });
  });
}

var app = (() => {
  var initialize = () => {
    headerMenu.init();
    cartItem.init();
    anchorToProductSection.init();
    addClassAfterDom();
  }
  return {
    init: initialize
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  app.init();
});

document.addEventListener('cart-drawer:open', () => {
  cartItem.init()
});

document.addEventListener('cart:items-rerendered', () => {
  cartItem.init();
});

var updateMobileHeaderSearchBar = () => {
  if(window.innerWidth <= 750 && document.body.classList.contains('new-builder-design')) {
    const header = document.querySelector('header');
    if (!header) return;
    if (window.scrollY > 0) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
}

window.addEventListener('scroll', () => {
  updateMobileHeaderSearchBar();
});
